






import { Vue, Component } from 'vue-property-decorator'
import { Action } from 'vuex-class'

@Component
export default class MinimalLayout extends Vue {
  @Action('CONTENT/loadContent') loadContent!: () => void

  loading = false

  async mounted () {
    this.loading = true
    await this.loadContent()
    this.loading = false
    this.$nextTick(() => {
      this.$store.commit('CONTENT/SET_LOADED', true)
    })
  }
}
